// extracted by mini-css-extract-plugin
export default {"container":"AccountManagementRecordSelect_container__VF4Py","label":"AccountManagementRecordSelect_label__H+XA3","disabled":"AccountManagementRecordSelect_disabled__5Nxai"};